import styled from "styled-components";

export const HeaderStyled = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--cor-primaria);
  height: 55px;
  width: 98%;
  border-radius: 0 0 40px 40px;
  box-shadow: 2px 2px 10px var(--shadow);
  margin: 0 auto;
  position: absolute;
  padding: 0 130px;
  top: 0;

  .logo {
    margin-top: 4px;
    width: 110px;
    height: fit-content;
    z-index: 2;
    cursor: pointer;
    img {
      max-width: 75%;
    }
  }
  .titulo {
    display: flex;
    width: 100%;
    margin: 0 auto;
    position: absolute;
    left: 0;
    justify-content: center;
    h1 {
      font-size: 22px;
      color: var(--branco);
    }
  }

  ul {
    display: flex;
    list-style: none;
    padding: 0;
    /* margin-top: 5px; */
    height: 100%;
    align-items: center;
    gap: 15px;
    .menu {
      text-decoration: none;
      color: var(--branco);
      display: flex;
      align-items: center;
      font-size: 20px;
      height: 100%;
      max-width: 150px;
      justify-content: end;
      cursor: pointer;

      z-index: 2;
      p {
        font-size: 16px;
        font-weight: 600;
        margin-right: 5px;
        text-align: center;
      }
    }

    .menu:hover {
      color: rgb(204, 204, 204);
    }

    .menuUser {
      position: relative;
      text-decoration: none;
      color: var(--branco);
      display: flex;
      align-items: center;
      justify-content: end;
      font-size: 20px;
      height: 100%;
      width: 150px;
      cursor: pointer;
      z-index: 2;
      transition: 1s;
      p {
        font-size: 16px;
        font-weight: 600;
        margin-right: 5px;
      }
      .submenu {
        position: absolute;
        top: 100%;
        right: 0;
        background: var(--degrade);
        border: 1px solid var(--branco);
        color: var(--branco);
        padding: 0;
        border-radius: 4px;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
        min-width: 120px;
        display: none;
        flex-direction: column;
        z-index: 10;
        cursor: pointer;

        li {
          padding: 8px 10px;
          text-align: center;
          font-size: 14px;
          white-space: nowrap;
        }
      }

      .submenu:hover {
        background: var(--cor-secundaria);
      }

      &:hover .submenu {
        display: flex;
      }
    }

    .icones {
      font-size: 35px;
    }
    .iconesUser {
      font-size: 38px;
    }
    .sairIcon {
      font-size: 40px;
      margin-left: 5px;
    }
  }

  @media only screen and (min-width: 1600px) {
    padding: 0 13%;
  }

  @media only screen and (max-width: 1150px) and (orientation: portrait) {
    display: none;
  }

  @media only screen and (max-width: 1150px) and (orientation: landscape) {
    display: none;
  }
`;

export const HeaderMobilStyled = styled.header`
  background: var(--degrade);
  display: none;
  justify-content: space-between;
  align-items: center;
  height: 55px;
  width: 96%;
  border-radius: 0 0 40px 40px;
  box-shadow: 2px 2px 10px var(--shadow);
  margin: 0 auto;
  position: absolute;
  padding: 0 20px;
  top: 0;
  z-index: 4;
  .menu {
    z-index: 2;
    font-size: 30px;
    color: var(--branco);
  }
  .titulo {
    display: flex;
    width: 100%;
    justify-content: center;
    h1 {
      max-width: 100%;
      text-align: center;
      font-size: 18px;
      color: var(--branco);
    }
  }
  .menuNav {
    display: flex;
    background: var(--degrade);
    width: 75px;
    padding: 15px;
    position: absolute;
    top: 55px;
    flex-direction: column;
    left: -9px;
    align-items: center;
    border-radius: 0 30px 30px 0;
    border: 1px solid var(--branco);
    animation: myAnim 1s ease 0s 1 normal forwards;
    .logo {
      img {
        margin-top: 4px;
        width: 50px;
      }
    }
    ul {
      display: flex;
      flex-direction: column;
      gap: 15px;
      margin-top: 15px;
      list-style: none;
      font-size: 60px;
      li {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 40px;
        cursor: pointer;
      }
    }
  }

  @media only screen and (max-width: 1150px) and (orientation: portrait) {
    display: flex;
    padding: 10px;
  }

  @media only screen and (max-width: 1150px) and (orientation: landscape) {
    display: flex;
  }
`;

export const NewHeaderStyled = styled.header`
  display: flex;
  flex-direction: column;
  width: 55px;
  height: 98dvh;
  justify-content: space-between;

  background: ${(props) =>
    props.darkMode
      ? `linear-gradient(
  180deg,
    rgba(44, 79, 23, 1) 0%,
    rgba(82, 133, 53, 1) 100%
  )`
      : "var(--degrade)"};
  z-index: 5;
  position: fixed;
  top: 1dvh;
  left: 0;
  border-radius: 0 15px 15px 0;
  padding: 5px;

  .selecMode {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    .mode {
      font-size: 30px;
      color: rgb(203, 203, 203);
      cursor: pointer;
      border-bottom: 2px solid transparent;
    }
    .active {
      border-bottom: 2px solid var(--branco);
      color: var(--branco);
    }
    .alertas {
      display: flex;
      cursor: pointer;
      position: relative;
      .icone {
        color: var(--branco);
        font-size: 25px;
      }
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        position: absolute;
        top: -3px;
        right: -5px;
        background-color: rgb(74, 74, 74);
        width: 18px;
        height: 18px;
        color: white;
        font-size: 14px;
      }
    }
  }
  .icones {
    font-size: 30px;
    color: var(--branco);
  }
  .logo {
    margin-top: 15px;
    cursor: pointer;
    img {
      width: 45px;
    }
  }
  ul {
    list-style: none;
  }
  .ulExite {
    display: flex;
    gap: 5px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* background-color: aqua; */
    .menu {
      position: relative;
      cursor: pointer;
      .sairIcon {
        font-size: 35px;
      }
      .iconesUser {
        font-size: 32px;
        cursor: pointer;
        color: var(--branco);
      }

      .labelNav {
        position: absolute;
        display: none;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        top: 25%;
        left: 50px;
        -webkit-animation: tracking-in-expand 0.7s
          cubic-bezier(0.215, 0.61, 0.355, 1) both;
        animation: tracking-in-expand 0.7s cubic-bezier(0.215, 0.61, 0.355, 1)
          both;
        color: ${(props) => (props.darkMode ? `white` : "black")};
        /* text-shadow: 1px 1px 1px black; */
      }
    }
    .menu:hover {
      .labelNav {
        width: 110px;
        max-width: max-content;
        display: flex;
      }
    }
    margin-bottom: 15px;
  }
  @media (max-width: 800px) {
    display: none;
  }
`;
